import React, { useEffect, useRef, useState } from "react";
import { UIProperties } from "../../cvp-webgames-core/Components/ui/UIProperties";
import { BaseConfig } from "../BaseConfig";
import "./ai-chat.css";
import { CoreBaseApiResult } from "../../cvp-webgames-core/Api/CoreBaseApi";
import { gameAPI } from "../../api/GameAPI";
import { setFocus } from "../../misc/tools";
import { coreConstantsGeneralUIs } from "../../cvp-webgames-core/Misc/CoreConstants";
import { CoreLoadingAnimationLoadingType } from "../../cvp-webgames-core/Components/ui/react/core-loading-animation";
import CoreLoadingUI, { CoreLoadingUIConfig } from "../../cvp-webgames-core/Components/ui/react/core-loading-ui";
import GameManager from "../../cvp-webgames-core/GameManager";

// const PictureType = {
// 	ai: './assets/chat-ai/ai-profile.jpg',
// 	person: './assets/chat-ai/person-profile.png'
// }

// const entries = [{
// 	pictureType: PictureType.ai,
// 	entries: [
// 		'Hello and welcome to the IV Demo AI Coach. I am here to assist you with any questions you may have about this scenario, based on the documentation that I have learned from. I am still learning and improving, so please bear with me if I make some errors. The documentation is the ultimate source of truth, so please consult it if you need a definitive answer.'
// 	]
// }];

// // {
// //   pictureType: PictureType,
// //   entries: string[]
// // }

// let showThinking = false;

// const AiChatUI = (props: UIProperties<AiChatUIConfig>) => {
// 	const [updateCounter, setUpdateCounter] = useState(0);
// 	const [forceUpdate, setForceUpdate] = useState(false);
// 	const root = useRef(null);

// 	useEffect(() => {
// 		if(entries.length === 1) {
// 			setFocus('entry0', () => {
// 				setFocus('ai-coach-bottom');
// 			})
// 		}
// 	})
	
// 	async function onSubmit() {
// 		let history = sessionStorage.getItem("ai_chat_history") || '';
// 		const inputField = root.current.querySelectorAll('input')[0];
// 		const textVal = inputField.value;
// 		inputField.value = ''
// 		let message = '';
// 		const entryAlreadyExists = false;//entries.length > 0 && entries[entries.length - 1].pictureType === PictureType.person;
// 		const newEntry = entryAlreadyExists ? entries[entries.length - 1] : {
// 			pictureType: PictureType.person,
// 			entries: [
// 				textVal
// 			]
// 		}

		

// 		if (entryAlreadyExists) {
// 			newEntry.entries.push(textVal);
// 		} else {
// 			entries.push(newEntry);
// 		}
// 		setFocus('entry' + (entries.length - 1), () => {
// 			setFocus('thinking', () => {
// 				setFocus('ai-coach-bottom');
// 			});
// 		});
// 		showThinking = true;
		
// 		setUpdateCounter(updateCounter + 1);

// 		try {
// 			const question = history + "You:" + textVal;
// 			const response = await gameAPI.chatGpt.askQuestion(question);
// 			message = response.data;
// 			history += `You: ${textVal}\nAI: ${response.data}\n`;
// 			sessionStorage.setItem("ai_chat_history", history);

// 		} catch (error: any) {
// 			// Consider implementing your own error handling logic here
// 			console.error(error.message);
// 			message = error.message;
// 		} finally {
// 			const filterMessage = () => {
// 				var result = message;
// 				result = result.replaceAll('AI:', '');
// 				result = result.replaceAll('Bot:', '');
// 				result = result.replaceAll('Alexa:', '');
// 				return result.trim();
// 			}
// 			entries.push({
// 				pictureType: PictureType.ai,
// 				entries: [
// 					filterMessage()
// 				]
// 			})
// 			setFocus('entry' + (entries.length - 1), () => {
// 				setFocus('ai-coach-bottom');
// 			});
// 			showThinking = false;
// 			setUpdateCounter(updateCounter + 1);
// 			setForceUpdate(!forceUpdate);
// 		}
// 	}
// 	return (
// 		<div ref={root} style={{
// 			pointerEvents: 'all'
// 		}}>
// 			<div style={{
// 				backgroundColor: 'black',
// 				opacity: 0.7,
// 				position: 'absolute',
// 				width: '100%',
// 				height: '1080px'
// 			}}>

// 			</div>
// 			<div style={{
// 				background: 'rgba(10, 14, 14, 1)',
// 				width: '800px',
// 				boxSizing: 'border-box',
// 				padding: '1em',
// 				borderRadius: '12px',
// 				position: 'absolute',
// 				overflow: 'hidden',
// 				left: '50%',
// 				top: '50%',
// 				transform: 'translate(-50%, -50%)'
// 			}} tabIndex={0} id="ai-coach-top">
// 				<button tabIndex={0} className="ai-close-bttn" style={{
// 					border: '0px solid black',
// 					width: '40px',
// 					height: '40px',
// 					borderRadius: '50px',
// 					position: 'absolute',
// 					right: '10px',
// 					top: '10px'
// 				}} onClick={() => {
// 					if(props.parameters.onCloseClicked) {
// 						props.parameters.onCloseClicked();
// 					}
// 				}}>
// 					X
// 				</button>
// 				<div style={{
// 					padding: '1em 0 2em',
// 					height: '660px',
// 					// height: '660px',
// 					overflow: 'auto'
// 				}}>
// 					{entries.map((entry, indx) => {
// 						return (
// 							<div  key={'top-level' + indx} style={{
// 								margin: '0 0 2em 0',
// 								position: 'relative',
// 								display: 'flex',
// 								flexDirection: entry.pictureType === PictureType.person ? 'row' : 'row-reverse'
// 							}}>
// 								<div style={{
// 									textAlign: 'center',
// 									margin: '0 1.2em 0 0'
// 								}}>
// 									<div style={{
// 										height: '35px',
// 										width: '35px',
// 										overflow: 'hidden',
// 										borderRadius: '50%',
// 										WebkitUserSelect: 'none',
// 										MozUserSelect: 'none',
// 										msUserSelect: 'none',
// 										userSelect: 'none',
// 										position: 'relative'
// 									}}>
// 										<img style={{
// 											height: '100%',
// 											width: 'auto'
// 										}} src={entry.pictureType} />
// 									</div>
// 								</div>

// 								{entry.entries.map((subEntry, subEntryIndx) => {
// 									return (
// 										<div key={'inner-level' + indx} style={{
// 											maxWidth: '55%',
// 											alignSelf: 'flex-end',
// 											display: 'block',
// 											marginRight: '20px'
// 										}}>
// 											<div>
// 												<span id={'entry' + indx} tabIndex={0} style={{
// 													width: 'fit-content',
// 													display: 'inline-table',
// 													wordWrap: 'break-word',
// 													background: '#14181a',
// 													fontSize: '16px',
// 													color: '#a3a3a3',
// 													padding: '0.5em 0.8em',
// 													lineHeight: '1.5',
// 													borderRadius: '6px',
// 													fontFamily: '"Lato", sans-serif'
// 												}}>{subEntry}</span>
// 											</div>
// 										</div>
// 									);
// 								})}


// 							</div>
// 						);
// 					})}
// 				</div>

// 				{true ? (
// 					<div style={{
// 						display: 'flex',
// 						visibility: showThinking ? 'visible' : 'hidden',
// 						flexDirection: 'row-reverse',
// 						alignItems: 'center',
// 						height: '100%',
// 					}}>
// 						<div>
// 							<div style={{
// 								height: '20px',
// 								width: '20px',
// 								overflow: 'hidden',
// 								borderRadius: '50%',
// 								WebkitUserSelect: 'none',
// 								MozUserSelect: 'none',
// 								msUserSelect: 'none',
// 								userSelect: 'none',
// 								position: 'relative'
// 							}}>
// 								<img style={{
// 									height: '100%',
// 									width: 'auto'
// 								}} src={PictureType.ai} />
// 							</div>
// 						</div>
// 						<div><span style={{
// 							color: '#a3a3a3',
// 							fontSize: '11px',
// 							marginRight: '8px'
// 						}} tabIndex={0} id="thinking">Thinking...</span></div>
// 					</div>
// 				) : (null)}

// 				<div style={{
// 					background: '#131719',
// 					borderRadius: '12px',
// 					padding: '0 1em',
// 					height: '55px',
// 					margin: '0.5em 0 0'
// 				}}>
// 					<div style={{
// 						display: 'flex',
// 						flexDirection: 'row',
// 						alignItems: 'center',
// 						height: '100%'
// 					}}>
// 						<input tabIndex={0} style={{
// 							margin: '0 1em 0 0',
// 							width: '100%',
// 							height: '100%',
// 							outline: 'none',
// 							position: 'relative',
// 							color: '#a3a3a3',
// 							fontSize: '16px',
// 							background: 'transparent',
// 							border: '0',
// 							fontFamily: '"Lato", sans-serif',
// 							resize: 'none'
// 						}} placeholder="Type a message..." onKeyUp={(event) => {
// 							if (event.key === 'Enter') {
// 								onSubmit();
// 							}
// 						}} id="ai-coach-bottom"/>
// 						<button style={{
// 							background: '#8147fc',
// 							height: '30px',
// 							minWidth: '30px',
// 							borderRadius: '50%',
// 							transition: '0.3s ease',
// 							position: 'relative',
// 							width: '30px',
// 							border: '0',
// 							padding: '0',
// 							outline: 'none',
// 							cursor: 'pointer',
// 							pointerEvents: showThinking ? 'none' : 'all'
// 						}} onClick={onSubmit}>
// 							<svg style={{
// 								stroke: '#FFF',
// 								fill: '#FFF',
// 								width: '50%',
// 								height: 'auto',
// 								position: 'absolute',
// 								top: '50%',
// 								left: '50%',
// 								transform: 'translate(-50%, -50%)'
// 							}} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-reactid="1036">
// 								<line x1="22" y1="2" x2="11" y2="13"></line>
// 								<polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
// 							</svg>
// 						</button>
// 					</div>
// 				</div>
// 			</div>
// 		</div>
// 	);
// }

const AiChatUI = (props: UIProperties<AiChatUIConfig>) => {
	const gm: GameManager = (window as any)['core-gm'];
	return (
		<div style={{
			pointerEvents: 'all'
		}}>
			<div style={{
				backgroundColor: 'black',
				opacity: 0.7,
				position: 'absolute',
				width: '100%',
				height: '1080px'
			}}>

			</div>
			<div style={{
				pointerEvents: 'all',
				border: '3px solid #C1CFF2',
				borderRadius: '55px',
				background: '#374668',
				width: '1500px',
				height: '980px',
				boxSizing: 'border-box',
				padding: '1em',
				position: 'absolute',
				overflow: 'hidden',
				left: '50%',
				top: '50%',
				transform: 'translate(-50%, -50%)'
			}} tabIndex={0} id="ai-coach-top">
				<button tabIndex={0} className="ai-close-bttn" style={{
					border: '0px solid black',
					width: '40px',
					height: '40px',
					borderRadius: '50px',
					position: 'absolute',
					right: '29px',
					// top: '10px'
				}} onClick={() => {
					if(props.parameters.onCloseClicked) {
						props.parameters.onCloseClicked();
					}
				}}>
					X
				</button>
				<div style={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					width: '300px',
					height: '300px'
				}}>
					<CoreLoadingUI parameters={{
						loadingContainerWidth: 300,
						loadingContainerHeight: 180,
						loadingZoomLvl: 2,
						loadingType: CoreLoadingAnimationLoadingType.four,
						customRootStyle: {
							backgroundColor: undefined
						}
					}}></CoreLoadingUI>
				</div>
				<div id="ai-coach-iframe-container" style={{
					position: 'absolute',
					left: '50%',
					top: '50%',
					transform: 'translate(-50%, -50%)',
					width: '90%',
					height: '98%',
					opacity: 0
				}}>
					<iframe style={{
						width: '100%',
						height: '100%'
					}} src="https://app-backend-j6sypbasovysq.azurewebsites.net" onLoad={() => {
						document.getElementById('ai-coach-iframe-container').classList.add('ai-coach-fade-in');
					}}></iframe>
				</div>
			</div>
		</div>
	);
}

export interface AiChatUIConfig extends BaseConfig {
	onCloseClicked?: () => void
}

export default AiChatUI;